export const ID = 'eae4ef3f-8247-4e49-818d-0e0f59a309bd';

export const NAME = 'Name, Address, Phone: Facility';
